// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBKuiKSHU8AwzgxBVMLHYlmADc8I1eCMB4",
    authDomain: "catch-photo.firebaseapp.com",
    databaseURL: "https://catch-photo.firebaseio.com",
    projectId: "catch-photo",
    storageBucket: "catch-photo.appspot.com",
    messagingSenderId: "124051295326",
    appId: "1:124051295326:web:fa57bb218b27feade378cf"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
